/* @flow */

import $ from 'jquery';
import moment from 'moment';
import get from 'lodash/get';
import swal from '../utils/swal';
import { exibirToastError } from '../utils/alertas';
import badgeStatus from '../extrato/badge-status';
import api from '../utils/api';

const thead = `
    <thead>
        <tr>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        Pedido
                    </font>
                </font>
            </th>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        Valor
                    </font>
                </font>
            </th>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        Usuário
                    </font>
                </font>
            </th>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        Pagamento
                    </font>
                </font>
            </th>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        Recebimento
                    </font>
                </font>
            </th>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        Status
                    </font>
                </font>
            </th>
            <th style="text-align: center;">
                <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                        Comissão
                    </font>
                </font>
            </th>
        </tr>
    </thead>
`;

const tbody = (extratos: Object[]) => `
    <tbody>
        ${extratos.map(extrato => (`
            <tr>
                <th scope="row">
                    <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                            #${extrato.order_id}
                        </font>
                    </font>
                </th>
                <td>
                    <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                            ${extrato.total}
                        </font>
                    </font>
                </td>
                <td>
                    <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                            ${extrato.variables.name}
                        </font>
                    </font>
                </td>
                <td>
                    <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                            ${moment(extrato.due_date).format('DD/MM/Y')}
                        </font>
                    </font>
                </td>
                <td>
                    <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                            ${moment(extrato.recebimento.return_date).format('DD/MM/Y')}
                        </font>
                    </font>
                </td>
                <td>
                    <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                            ${badgeStatus(extrato.status)}
                        </font>
                    </font>
                </td>
                <td>
                    <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                            ${extrato.commission}
                        </font>
                    </font>
                </td>
            </tr>
        `)).join('')}
    </tbody>
`;

const semExtratos = `
    <div class="alert m-alert alert-warning">
        <div class="m-alert__text">Nenhuma unidade encontrada</div>
    </div>`;

const extratosPorEmpresa = async (empresasId: number) => {
    try {
        const { data: { items: extratos } } = await api.getExtratosPorEmpresa(
            empresasId,
            {
                dataInicial: moment().subtract(30, 'days').format('YYYY-MM-DD'),
                dataFinal: moment().format('YYYY-MM-DD'),
            },
        );

        swal.fire({
            title: 'Extratos',
            width: 1000,
            scrollbarPadding: false,
            confirmButtonColor: '#36a3f7',
            html: `
                <br/>
                <div
                    class="m-section" m-scrollable m-scrollable--track"
                    data-scrollable="true"
                    style="max-height: 400px"
                >
                    <div class="m-section__content">
                        <table class="table m-table m-table--head-bg-brand">
                            ${thead}
                            ${tbody(extratos)}
                        </table>
                        ${extratos.length < 1 ? semExtratos : ''}
                    </div>
                </div>`,
            focusConfirm: false,
        });

        $(document).ready(() => {
            window.mApp.init();
        });
    } catch (error) {
        exibirToastError(get(
            error,
            'response.data.message',
            'Algo deu errado',
        ));
    }
};

export default extratosPorEmpresa;
